/** An error emitted by Sentry SDKs and related utilities. */
class SentryError extends Error {
  constructor(message) {
    var logLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'warn';
    super(message);
    this.message = message;
    this.logLevel = logLevel;
  }

}

export { SentryError };